import { useState, useEffect, useRef } from "react";
import cn from "classnames";
import {
  requestTypes,
} from "./CVOConstants";
import { formatDate } from '../../functions/textFormatting';

const SummarySection = ({ children, title }) => {
  //
  const wrapperRef = useRef(null);
  const [totalHeight, setTotalHeight] = useState("auto");
  const [show, setShow] = useState(false);

  const update = (entries) => {
    let h = entries[0].contentRect.height;
    setTotalHeight(`${h}px`);
  };

  useEffect(() => {
    const obs = new ResizeObserver(update);
    if (wrapperRef.current) {
      obs.observe(wrapperRef.current);
    }
    return () => {
      obs.disconnect();
    };
  }, [wrapperRef.current]);

  return (
    <div className="summary-section col-12 col-medium">
      <p onClick={() => { setShow(!show); }} className={cn("summary-title aui-headline-4 mb-3", {"show": show})}>{title}</p>
      <hr className="mb-3 d-medium-none" />
      <div style={{ height: show ? totalHeight : "0" }} className="summary-section__collapse">
        <div ref={wrapperRef}>
          <div className="py-1" />
          {children}
          <div className="py-1" />
        </div>
      </div>
    </div>
  );
}

const Summary = ({ submittedData }) => {
  return (
    <div className="pb-5">
      <h1 className="aui-headline-3 mb-5 mb-medium-3 pt-5">Summary</h1>
      <hr className="mb-5 d-none d-medium-block" />
      <div className="row">
        <SummarySection title="Vehicle details">
          <p className="summary-label">VIN</p>
          <p className="mb-3">{submittedData.vin}</p>
          <p className="summary-label">Registration</p>
          <p className="mb-3">{submittedData.rego}</p>
          <p className="summary-label">State</p>
          <p className="mb-3">{submittedData.regoState}</p>
        </SummarySection>
        <SummarySection title="Your details">
          <p className="summary-label">First name</p>
          <p className="mb-3">{submittedData.firstName}</p>
          <p className="summary-label">Last name</p>
          <p className="mb-3">{submittedData.lastName}</p>
          <p className="summary-label">Mobile</p>
          <p className="mb-3">{submittedData.phone}</p>
          <p className="summary-label">Email</p>
          <p className="mb-3">{submittedData.email}</p>
          <p className="summary-label">Address</p>
          <p className="mb-3">{submittedData.address}, {submittedData.suburb} {submittedData.postCode}</p>
        </SummarySection>
        {submittedData.requestType === requestTypes.NO_LONGER_OWN && <SummarySection title="New owner details">
          {submittedData.newOwnerType === "private" && <>
            <p className="summary-label">First name</p>
            <p className="mb-3">{submittedData.newOwnerName}</p>
            <p className="summary-label">Last name</p>
            <p className="mb-3">{submittedData.newOwnerLName}</p>
            <p className="summary-label">Mobile</p>
            <p className="mb-3">{submittedData.newOwnerPhone}</p>
            <p className="summary-label">Email</p>
            <p className="mb-3">{submittedData.newOwnerEmail}</p>
            <p className="summary-label">Address</p>
            <p className="mb-3">{submittedData.newOwnerAddress}, {submittedData.newOwnerSuburb} {submittedData.newOwnerPostcode}</p>
          </>}
          {submittedData.newOwnerType === "dealer" && <>
            <p className="summary-label">Dealer name</p>
            <p className="mb-3">{submittedData.dealerName}</p>
          </>}
        </SummarySection>}
        {submittedData.requestType !== requestTypes.PERSONAL_DETAILS_CHANGED &&
          <SummarySection
            title={submittedData.requestType === requestTypes.NO_LONGER_OWN ? "Sale details" : submittedData.requestType === requestTypes.NEW_OWNER ? "Purchase details" : "Write-off details"}
          >
            {submittedData.requestType === requestTypes.NO_LONGER_OWN && <p className="summary-label">Date of sale</p>}
            {submittedData.requestType === requestTypes.NEW_OWNER && <p className="summary-label">Date of purchase</p>}
            {submittedData.requestType === requestTypes.WRITTEN_OFF && <p className="summary-label">Write-off date</p>}
            <p className="mb-3">{formatDate(submittedData.dateOfChange)}</p>
          </SummarySection>
        }
      </div>
    </div>
  );
};

export default Summary;
